module.exports = __webpack_public_path__ + "static/hack-the-army.b3f0b2f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/home/awards/hack-the-army.png
// module id = 119
// module chunks = 35783957827783 169928946856436